<template>
  <v-layout
    wrap
    align-center
    purchase
  >
    <v-flex xs3>
      <v-img
        :src="user.image"
        max-width="50"
      />
    </v-flex>
    <v-flex
      xs9
      pl-1
    >
      <v-tooltip
        top
        min-width="300"
      >
        <template v-slot:activator="{ on }">
          <div
            class="text-left"
            v-on="on"
          >
            <b><small>{{ user.name }}</small></b>
          </div>
        </template>
        <small>
          <ul class="tariff-description">
            <li
              v-for="(descItem, i) in selectedItemDesc(user.description)"
              :key="i"
            >
              <span>{{ descItem }}</span>
            </li>
          </ul>
        </small>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Purchase",
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  methods:{
    selectedItemDesc: function (desc){
      if (desc){
        return desc.split(/\n/)
      }
      return []
    },
  },
};
</script>

<style lang="scss" scoped>
.tariff-description {
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 20px;
    li {
      font-weight: 400;
      font-size: 13px;
      text-align: left;
      line-height: 130%;
      color: var(--color-primary-text);
      padding: 0 30px 0 0;
      position: relative;
    }
  }
</style>